import { render, staticRenderFns } from "./VatId.vue?vue&type=template&id=0df56745&"
import script from "./VatId.vue?vue&type=script&lang=js&"
export * from "./VatId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\bensz\\Documents\\Frontend Studios\\plentyDevTool\\13441\\372\\stabiloVueTheme\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df56745')) {
      api.createRecord('0df56745', component.options)
    } else {
      api.reload('0df56745', component.options)
    }
    module.hot.accept("./VatId.vue?vue&type=template&id=0df56745&", function () {
      api.rerender('0df56745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/VatId.vue"
export default component.exports